<div class="drag-handle">
  <pl-drag-handle [dragHandleSize]="3" [dragHandleOffset]="2"></pl-drag-handle>
  <fa-icon [fixedWidth]="true" size="xs" [icon]="['fas', 'chevron-down']"></fa-icon>
</div>
